import { useRef, useState } from 'react';
import { PlayFilled } from '@teachstonellc/component-library/dist/icons';

interface VideoPlayerProps {
  source?: string;
}

export function VideoPlayer({ source }: VideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    videoRef.current?.play();
    setIsPlaying(true);
  };

  if (source && source.length > 0) {
    return (
      <div className="relative w-full aspect-video mx-auto bg-black overflow-hidden">
        <video
          ref={videoRef}
          src={source}
          controls={isPlaying}
          controlsList="nodownload"
          className="w-full h-full object-contain"
          preload="metadata"
        />

        {!isPlaying && (
          <button
            onClick={handlePlay}
            className="absolute inset-0 flex items-center justify-center bg-black/40 hover:bg-black/60 transition"
            aria-label="Play video"
          >
            <PlayFilled color="white" size={100} />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="w-full aspect-video bg-ds-gray-6 flex items-center justify-center">
      <PlayFilled color="white" size={100} />
    </div>
  );
}
